<div class="aems-card m-b-12">
  <form [formGroup]="remarkForm">
    <mc-textarea
      label="Remarks"
      ngDefaultControl
      maxlength="255"
      placeholder="Please indicate general condition of box, main damage consists, wear and team share of repair, repair in other mode required."
      rows="3"
      fit="small"
      formControlName="remark">
    </mc-textarea>
  </form>
</div>
